<div
  class="flex flex--column justify--center items--center"
  style="height: 80vh;"
>
  <img
    src="lantern/assets/images/pages/not-found/404.png"
    style="height: 80px; width: auto;"
  />
  <div class="f--1 bold text--dark pt--4 pb--3">Page not found</div>
  <div class="f--5 text--light">
    Check the URL or return to the <ta-link taRouterLink="/">homepage</ta-link>.
  </div>
</div>
